import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { CreateImpactAgentCorrectionFeedbackParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import useSnackbar from "utils/useSnackbar";

export const CreateImpactAgentCorrectionFeedback = graphql(/* GraphQL */ `
	mutation createImpactAgentCorrectionFeedback(
		$params: CreateImpactAgentCorrectionFeedbackParams!
	) {
		createImpactAgentCorrectionFeedback(params: $params) {
			success
			error {
				code
				message
			}
		}
	}
`);

export function useCreateImpactAgentCorrectionFeedback() {
	const { handleError, handleSuccess } = useSnackbar();
	const [createImpactAgentCorrectionFeedback, { loading }] = useMutation(
		CreateImpactAgentCorrectionFeedback
	);

	const submitFeedback = useCallback(
		async (params: CreateImpactAgentCorrectionFeedbackParams) => {
			try {
				const result = await createImpactAgentCorrectionFeedback({
					variables: { params },
				});

				const response = result.data?.createImpactAgentCorrectionFeedback;

				if (response?.error) {
					handleError(response.error);
					return false;
				}

				if (response?.success) {
					handleSuccess("Thanks for your feedback");
					return true;
				}

				return false;
			} catch (error) {
				handleError(error);
				return false;
			}
		},
		[createImpactAgentCorrectionFeedback, handleError, handleSuccess]
	);

	return { submitFeedback, loading };
}
